import { getAxiosUrl } from '@app/configs/axios';
import { useConfigStore } from '@shared/stores/config';
import { usePresetStore } from '@shared/stores/preset';

export const useApiBaseUrl = () => {
    const preset = useConfigStore((s) => s.preset);
    const presets = usePresetStore((s) => s.presets);
    return getAxiosUrl({ preset, presets });
};
